exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FloatingButton_button_2Nd92{position:relative;top:2px;bottom:10px;display:inline-block;border:none;padding:5px 10px;cursor:pointer;-webkit-transition:.2s;transition:.2s;font-weight:700;text-decoration:underline}.FloatingButton_button_2Nd92,.FloatingButton_button_2Nd92:hover{color:#000}", ""]);

// exports
exports.locals = {
	"button": "FloatingButton_button_2Nd92"
};